import { Box, Skeleton } from "@mui/material";
import ReportCard from "datasets/pages/dashboards/components/ReportCard";
import useDatasetReports from "datasets/pages/dashboards/hooks/useDatasetReports";
import CardGrid from "~/components/CardGrid";

const Skeletons = () => (
  <>
    {Array.from({ length: 8 }).map((_, i) => (
      <Skeleton key={i} variant="rounded" height={205} />
    ))}
  </>
);

const DatasetReportList = () => {
  const { data: reportList, isLoading } = useDatasetReports();

  return (
    <Box width="100%">
      <CardGrid>
        {isLoading ? (
          <Skeletons />
        ) : (
          reportList?.map((report) => <ReportCard key={report.id} report={report} />)
        )}
      </CardGrid>
    </Box>
  );
};

export default DatasetReportList;
